import { Component, OnInit } from "@angular/core";
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

@Component({
  selector: "app-excel-modal",
  template: `
    <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
           <h4 class="modal-title">Formato del Excel</h4>
         </div>
         <div class="modal-body">
           <p>El Excel generado debe tener el siguiente formato.</p>
           <div class="row">
             <div class="col-table col-2">Día</div>
             <div class="col-table col-4">Concepto / Referencia</div>
             <div class="col-table col-2">Cargo</div>
             <div class="col-table col-2">Abono</div>
             <div class="col-table col-2">Saldo</div>
           </div>
           <div class="row">
             <div class="col-table col-2">12/12/2017</div>
             <div class="col-table col-4">CHEQUE PAGADO NO./CH-0008888</div>
             <div class="col-table col-2">4462,72</div>
             <div class="col-table col-2">0</div>
             <div class="col-table col-2">214609,24</div>
           </div>
         </div>
         <div class="modal-footer">
           <button type="button" class="btn btn-primary" (click)="close()">Acepto</button>
         </div>
       </div>
    </div>
  `,
  styles: [
    `
      .col-table{
        font-size: 0.8em;
        border: 1px solid #f2f2f2;
      }
    `
  ]
})
export class ExcelModalComponent extends DialogComponent<any, any> {
  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/core/component/modal/excel.modal.ts